export const getConsultingList = ""//获取咨询列表
export const updateRemark = ""//更新备注

export const getSignContractList = "/works/signContract/listAll"//获取签约列表

export const getSignContract = `/works/signContract/`; // 查询签约信息详情

export const updateStatus = "/works/signContract/updateStatus"//修改审核状态

export const updateSignContract = "/works/signContract/update"; // 修改禁用状态

export const getSignContractRecordList = "/works/signContract/listRecordAll"//获取签约列表记录

export const downloadSignContract = `/works/signContract/downloadSignContract`

export const  listAll = '/works/counsel/listAll'

export const  updateCounsel = '/works/counsel/updateCounsel'
